import { useMutation } from "@apollo/client/react";
import { SET_INVOICE_TAGS } from "../../mutations/invoices/setInvoiceTags";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useSetInvoiceTags = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [setInvoiceTags, { data, loading, error }] = useMutation<{
    invoice: { setInvoiceTags: { success: boolean } };
  }>(SET_INVOICE_TAGS, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: noRefetch
      ? []
      : [
          GET_CLIENT_ASSESSMENT_INVOICES,
          GET_INVOICE_ASSESSMENT_DETAILS,
          GET_CLIENT_INVOICES,
          GET_INVOICE_LATEST_VALIDATION_RESULT,
        ],
    awaitRefetchQueries: true,
  });

  return { setInvoiceTags, data, loading, error };
};
